import axios from 'axios';
import React, { useEffect, useContext, useState, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import Slider from "react-slick";
import VegIcon from "../../Icon/veg.svg";
import { showToast } from '../../showTost';
import ProductData from './ProductData';
import AddonItemData from './AddonItemData';
import SubAddonItemData from './SubAddonItemData';
import NotFound from '../NotFound';
import PureVegIcon from "../../Image/pureveg.png";
import FssaiLogo from "../../Image/fssai.png";
const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-gray-200 p-[7px] rounded-[50px] absolute z-10 right-[45px] max-_430_:-top-[25px] -top-[27px] transform -translate-y-1/2 cursor-pointer"
    >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
        </svg>
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-gray-200 p-[7px] rounded-[50px] absolute z-10 right-[0px] max-_430_:-top-[25px] -top-[27px] transform -translate-y-1/2 cursor-pointer"
    >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.6919 12.2871C21.6539 12.3791 21.599 12.462 21.53 12.531L14.53 19.531C14.384 19.677 14.192 19.751 14 19.751C13.808 19.751 13.616 19.678 13.47 19.531C13.177 19.238 13.177 18.763 13.47 18.47L19.1899 12.75H3C2.586 12.75 2.25 12.414 2.25 12C2.25 11.586 2.586 11.25 3 11.25H19.189L13.469 5.53005C13.176 5.23705 13.176 4.76202 13.469 4.46902C13.762 4.17602 14.237 4.17602 14.53 4.46902L21.53 11.469C21.599 11.538 21.6539 11.6209 21.6919 11.7129C21.7679 11.8969 21.7679 12.1031 21.6919 12.2871Z" fill="#25314C" />
        </svg>

    </div>
);

const RestaurantsDetails = () => {

    const { BaseUrl, iscustomisable, setIsCustomisable, customisableitem, totalcart, setTotalCart, setCustomisableItem, callHomeApi } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [restuarantdata, setRestuarantData] = useState("");
    const [couponlist, setCouponList] = useState([]);
    const [itemlist, setItemList] = useState([]);
    const [vegtoggle, setVegToggle] = useState(false);
    const [selectitem, setSelectItem] = useState();
    const [selectitemprice, setSelectItemPrice] = useState(0);
    const [showcouponitem, setShowCouponItem] = useState("");
    const [isrepeat, setIsRepeat] = useState(false);
    const [selectrepeatorder, setSelectRepeatOrder] = useState("");
    const [repeatradiobtn, setRepeatRadioBtn] = useState(false);
    const [repeatorderlist, setRepeatOrderList] = useState("");
    const [isfav, setIsFav] = useState(0);
    const [coords, setCoords] = useState({ lat: "", long: "" });
    const [localcartdata, setLocalCartData] = useState([]);
    const [selectaddonitem, setSelectAddonItem] = useState([]);
    const [isshow, setIsShow] = useState(false);
    const [copydata, setCopyData] = useState("");
    const [status, setStatus] = useState(false);
    const [isstep, setIsStep] = useState("1");
    const [addonlimit, setAddonLimit] = useState("0");
    const [subaddonshow, setSubAddonShow] = useState(false);
    const [subAddonData, setSubAddonData] = useState("");
    const [itemstate, setItemState] = useState([]);
    const [shownumber, setShowNumber] = useState(false);
    const [ismenulist, setIsMenuList] = useState(false);
    const [ratonglength, setReatinglength] = useState(0);

    const StyleRef = useRef();
    const MenuListRef = useRef();
    const sectionRefs = useRef({});

    const Params = useParams();

    const Userid = secureLocalStorage.getItem("Userid");
    const rest_id = Params.id;
    const currency = secureLocalStorage.getItem("currency");

    const navigate = useNavigate();

    const CouponList = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    itemlist.forEach((section) => {
        if (!sectionRefs.current[section.id]) {
            sectionRefs.current[section.id] = React.createRef();
        }
    });

    useEffect(() => {
        window.scrollTo(0, 0);

        if (!Userid) {
            if (!rest_id) {
                navigate("/");
            }
        }

        const IsAddedLocation = secureLocalStorage.getItem("Location");
        setLoading(true);
        if (IsAddedLocation) {
            const { lat, long } = JSON.parse(IsAddedLocation);
            setCoords({ lat, long });
            handleFetchDetails(lat, long, 0);
        } else {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    setCoords({ lat, long });
                    handleFetchDetails(lat, long, 0);
                }
            )
        }
    }, [callHomeApi]);

    useEffect(() => {
        iscustomisable
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [iscustomisable]);

    useEffect(() => {
        const TotalAddonPrice = selectaddonitem?.reduce((sum, item) => sum + Number(item.price), 0);
        const TotalAddonPrice2 = itemstate?.map(item => item.data?.reduce((sum, item) => sum + Number(item.price), 0)).join(", ");
        setSelectItemPrice(TotalAddonPrice + Number(TotalAddonPrice2));
    }, [selectaddonitem, itemstate]);

    useEffect(() => {
        if (loading) return;

        if (localcartdata?.length >= 1) {
            const LocalData = secureLocalStorage.getItem("localcartdata");
            if (LocalData) {
                var { restdata } = JSON.parse(LocalData);
            }

            const RestData = {
                rest_id: restuarantdata?.rest_id,
                rest_title: restuarantdata?.rest_title,
                rest_img: restuarantdata?.rest_img,
                rest_landmark: restuarantdata?.rest_landmark,
                rest_distance: restuarantdata?.rest_distance,
                rest_dcharge: restuarantdata?.rest_dcharge,
                rest_charge: restuarantdata?.rest_charge
            }

            const RestuarantData = restdata ? (status ? RestData : restdata) : RestData;
            const Data = { cartitem: localcartdata, restdata: RestuarantData }
            secureLocalStorage.setItem("localcartdata", JSON.stringify(Data));

            const totalcart = localcartdata?.reduce((sum, item) => sum + item?.qty, 0);
            setTotalCart(totalcart);
        } else {
            secureLocalStorage.removeItem("localcartdata");
            setTotalCart(0);
        }


    }, [localcartdata]);

    const handleFetchDetails = (lats, longs, fid) => {
        const uid = secureLocalStorage.getItem("Userid") || "0";
        if (uid) {
            axios.post(`${BaseUrl}/eapi/e_rest_data.php`, { uid, rid: rest_id, fid, lats, longs })
                .then((res) => {
                    console.log('e_rest_data.php', res.data);
                    const { ResponseCode, RestData } = res.data;

                    if (ResponseCode === "200") {

                        if (RestData.restuarant_data.length <= 0) {
                            setLoading(false);
                            return;
                        }

                        setRestuarantData(RestData.restuarant_data[0]);
                        setIsFav(RestData.restuarant_data[0]?.IS_FAVOURITE);
                        setCouponList(RestData.Coupon);

                        const LocalData = secureLocalStorage.getItem("localcartdata");
                        let JsonData = [];
                        if (LocalData) {
                            const { cartitem } = JSON.parse(LocalData);
                            JsonData = cartitem;
                            setLocalCartData(cartitem);
                            const totalcart = cartitem.reduce((sum, item) => sum + item.qty, 0);
                            setTotalCart(totalcart);
                        }

                        setReatinglength(RestData.Review_Data.length);

                        const ProductData = RestData.Product_Data;
                        const FilterData = ProductData?.map((product) => {
                            const updatedMenuItems = product?.Menuitem_Data?.map((item) => {
                                if (item.is_customize === "0") {
                                    const matchedItem = JsonData?.find((data) => data.pid === item.id);
                                    return matchedItem ? { ...item, totalcart: matchedItem.qty } : item;
                                } else {
                                    const matchedItems = JsonData?.filter((data) => data.pid === item.id);
                                    const totalcart = matchedItems.reduce((sum, item) => sum + item.qty, 0);
                                    return matchedItems ? { ...item, totalcart: totalcart } : item;
                                }
                            });

                            return {
                                ...product,
                                Menuitem_Data: updatedMenuItems
                            };
                        });



                        setItemList(FilterData);
                    }

                    setLoading(false);
                })
                .catch((error) => {
                    console.error("e_rest_data.php", error);
                })
        }
    }

    const formatCustomDate = (dateStr) => {

        const date = new Date(dateStr);

        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        let hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours > "12" ? "PM" : "AM";

        return `${month} ${day < 10 ? `0${day}` : day}, ${year} ${hours}:${minutes} ${ampm}`
    };

    const handleAddToFavorite = (rid) => {
        const uid = secureLocalStorage.getItem("Userid");

        axios.post(`${BaseUrl}/eapi/e_fav.php`, { uid, rid })
            .then((res) => {
                // console.log("e_fav.php", res);
                const { ResponseCode, ResponseMsg } = res.data;
                const Toastid = ResponseCode === "200" ? "success" : "error";
                showToast({ title: ResponseMsg, id: Toastid });
                if (ResponseCode === "200") {
                    setIsFav(isfav === 1 ? 0 : 1);
                }
            })
            .catch((error) => {
                console.error("e_fav.php", error);
            })
    }

    const handleAddToCart = (data) => {
        const matchedOrders = localcartdata.filter(order => order.pid === data.id);
        let isError = false;

        if (matchedOrders.length >= 1) {

            const AllMatch = itemstate.every(item => {
                return matchedOrders.some(order => {
                    return order.addon.some(data => {
                        return data.title === item.title;
                    });
                });
            });

            if (AllMatch) {

                const checkMatchingTitles = (matchedOrders, itemstate) => {
                    return itemstate.every(selectedItem => {
                        return matchedOrders.some(order => {
                            return order.addon.some(addon => {
                                const addonTitles = addon.data.map(d => d.title).sort();
                                const selectedTitles = selectedItem.data.map(d => d.title).sort();
                                if (addonTitles.length !== selectedTitles.length) return false;
                                return addonTitles.every((title, index) => title === selectedTitles[index]);
                            });
                        });
                    });
                };
                const isValid = checkMatchingTitles(matchedOrders, itemstate);

                if (!isValid) {
                    isError = true;
                } else {
                    handleIncrement(data);
                    setIsCustomisable(false);
                    setSelectItemPrice(0);
                    setSelectAddonItem([]);
                    handleCloseModel(2);
                    setStatus(false);
                }

            } else {
                isError = true;
            }

        } else {
            isError = true;
        }

        if (isError) {
            if (status) {
                setLocalCartData("");
                setTimeout(() => {
                    handleAddNewItem(data);
                }, 100);
                return;
            }

            handleAddNewItem(data);
        }

    };

    const handleAddNewItem = (data) => {
        let selectedItemData;

        const updatedItemList = itemlist?.map(product => {
            const updatedMenuItems = product.Menuitem_Data?.map(menuItem => {
                if (menuItem.id === data.id) {
                    const newQty = menuItem.totalcart ? menuItem.totalcart + 1 : 1;
                    const totalAddonPrice = Number(data?.price) + Number(selectitemprice);
                    selectedItemData = {
                        pid: menuItem.id,
                        price: data?.price,
                        title: menuItem.title,
                        cost: data.is_customize === "1" ? totalAddonPrice : totalAddonPrice * newQty,
                        copycost: data.is_customize === "1" ? totalAddonPrice : totalAddonPrice * newQty,
                        qty: data.is_customize === "1" ? 1 : newQty,
                        is_customize: data.is_customize,
                        addon: itemstate,
                        type: data.is_veg,
                    };
                    return { ...menuItem, totalcart: newQty };
                }
                return menuItem;
            });

            return {
                ...product,
                Menuitem_Data: updatedMenuItems,
            };
        });

        setLocalCartData(prev => [...prev, selectedItemData]);
        setItemList(updatedItemList);
        setIsCustomisable(false);
        setSelectItemPrice(0);
        setSelectAddonItem([]);
        handleCloseModel(2);
        setStatus(false);
    };

    const handleIncrement = (data) => {

        const FilterData = itemlist.map((product) => {
            const updatedMenuItems = product.Menuitem_Data.map((item) => {
                if (item.id === data.id) {
                    const Count = item.totalcart + 1;
                    return { ...item, totalcart: Count }
                }
                return item;
            })
            return { ...product, Menuitem_Data: updatedMenuItems };
        });


        const LocalFilterData = localcartdata.map((product) => {
            if (product.pid === data.id) {
                const Count = product.qty + 1;
                const cost = product.is_customize === "1" ? (product.copycost * Count) : (product.price * Count);
                return { ...product, qty: Count, cost }
            }
            return product;
        });

        setLocalCartData(LocalFilterData);
        setItemList(FilterData);
    }

    const handleDecrement = (data) => {

        const FilterData = itemlist.map((product) => {
            const updatedMenuItems = product.Menuitem_Data.map((item) => {
                if (item.id === data.id) {
                    const Count = item.totalcart - 1;
                    return { ...item, totalcart: Count }
                }
                return item;
            })
            return { ...product, Menuitem_Data: updatedMenuItems };
        });

        const UpdatedCart = localcartdata.map(product => {
            if (product.pid === data.id) {
                const Count = product.qty - 1;
                if (Count === 0) return null;
                return { ...product, qty: Count, cost: (product.cost - Number(product.price)) };
            }
            return product;
        }).filter(Boolean);
        setLocalCartData(UpdatedCart);
        setItemList(FilterData);
    }

    const handleAllFuction = (index, data) => {
        if (index === 1) {
            handleAddToCart(data);
        } else if (index === 2) {
            handleIncrement(data);
        } else if (index === 3) {
            handleDecrement(data);
        } else if (index === 4) {
            const RepeatList = localcartdata.filter(item => item.pid === data.id && item.addon);
            setItemState(RepeatList);
            setRepeatOrderList([...RepeatList]);
            setIsRepeat(true);
        } else if (index === 5) {
            setIsShow(true);
            setCopyData(data);
            setTimeout(() => {
                StyleRef.current.classList.add('item_added_close');
            }, 100);
        } else if (index === 6) {
            setSelectItem(data);
            handleFilterData(data);
            setIsCustomisable(true);
        }

        if (index === 4 || index === 5 || index === 6) {
            const GetLength = data.addondata.some(item => item.addon_item_data.some(item => item.subaddondata.length >= 1));
            setAddonLimit(GetLength ? data.required_step : 0);
        }
    }

    const handleUserChoose = () => {
        setItemState([]);
        setIsRepeat(false);
        handleFilterData(customisableitem);
        setIsCustomisable(true);
    }

    const handleFilterData = (data) => {
        const FilterData = data.addondata.map(addon => {
            if (!addon.additem) {
                if (addon.addon_is_radio === "1" && addon.addon_is_required === "1") {
                    setSelectAddonItem(prev => [...prev, addon.addon_item_data[0]]);
                    if (addon.addon_item_data[0].subaddondata.length >= 1) {
                        setAddonLimit(1);
                    } else {
                        setItemState(prev => {
                            const exists = (prev || []).some(item => item.title === "Order");
                            if (exists) {
                                return (prev || []).map(item => {
                                    if (item.title === "Order") {
                                        return { ...item, data: [...item.data, addon.addon_item_data[0]] };
                                    }
                                    return item;
                                });
                            } else {
                                return [...(prev || []), { title: "Order", data: [addon.addon_item_data[0]] }];
                            }
                        });
                    }
                    return { ...addon, additem: "1" }
                }
                return addon;
            }
            return addon;
        });

        setCustomisableItem({ ...data, addondata: FilterData });
    }

    const handleRepeatOrder = () => {
        if (itemstate.length >= 2) {
            setRepeatRadioBtn(true);

            if (repeatradiobtn && !selectrepeatorder) {
                showToast({ title: "Select repeat order !!", id: "error" });
                return;
            }

            if (selectrepeatorder) {
                setLocalCartData(prev => [...prev, itemstate[selectrepeatorder - 1]]);
                setRepeatRadioBtn(false);
                setSelectRepeatOrder("");
                setIsRepeat(false);
                setItemState([]);
                handleIncrement(selectitem);
            }
        } else {
            setLocalCartData(prev => [...prev, ...itemstate]);
            setRepeatRadioBtn(false);
            setIsRepeat(false);
            setRepeatRadioBtn("");
            handleIncrement(selectitem);
            setItemState([]);
        }
    }

    const handleShowModel = (index) => {
        StyleRef.current.classList.remove('item_added_close');
        setTimeout(() => {
            setIsShow(false);
        }, 500);

        if (index === 1) {
            if (copydata.is_customize === "0") {
                setLocalCartData([]);
                setTimeout(() => {
                    handleAddToCart(copydata);
                }, 200);
            } else {
                setTimeout(() => {
                    setSelectItem(copydata);
                    handleFilterData(copydata);
                    setIsCustomisable(true);
                    setStatus(true);
                }, 200);
            }

        }
    }

    const handleCloseModel = (index) => {
        if (index === 1) {
            setIsCustomisable(false);
            setSelectItemPrice(0);
            setSelectItem("");
            setSubAddonShow(false);
        } else if (index === 2) {
            setSubAddonShow(false);
            setIsStep("1");
        } else {
            setIsRepeat(false);
            setRepeatRadioBtn(false);
            setSelectRepeatOrder("");
        }
        setItemState([]);
    }

    const handleContinue = () => {
        const someHaveNoSubaddons = selectaddonitem.some(item => item.subaddondata.length <= 0);

        if (someHaveNoSubaddons) {
            handleAddToCart(customisableitem, 1);
            return;
        }

        setIsStep("1");
        setSubAddonShow(true);
    }

    useEffect(() => {
        if (selectaddonitem.length >= 1) {
            const isTure = selectaddonitem.some(item => item.subaddondata.length <= 0);
            if (isTure) {
                setAddonLimit(0);
            }
        }
    }, [selectaddonitem]);

    const handleMap = () => {
        const googleMapsUrl = `https://www.google.com/maps?q=${restuarantdata?.rest_lats},${restuarantdata?.rest_longs}`;
        window.open(googleMapsUrl, '_blank');
    };

    const handleCall = () => {
        if (window.innerWidth > 430) {
            setShowNumber(true);
        }
        window.location.href = `tel:${restuarantdata?.rest_mobile}`;
    }

    const handleSearch = () => {
        const Data = {
            title: restuarantdata?.rest_title,
            searchtype: 2,
            rest_id
        }
        navigate("/search", { state: Data });
        secureLocalStorage.setItem("searchtype", 2);
        secureLocalStorage.setItem("isopen", restuarantdata.rest_is_open);
    }

    const handleMenuOpenClose = (index) => {
        if (index === 1) {
            setIsMenuList(true);
            setTimeout(() => {
                if (MenuListRef.current) {
                    MenuListRef.current.style.transform = 'translateY(0px) scale(1)';
                }
            }, 50);
        } else {
            if (MenuListRef.current) {
                MenuListRef.current.style.transform = 'translateY(290px) scale(0)';
            }
            setTimeout(() => {
                setIsMenuList(false);
            }, 500);
        }
    };

    const handleScrollToSection = (id) => {
        setIsMenuList(false);
        const sectionRef = sectionRefs.current[id];
        if (sectionRef && sectionRef.current) {
            const yOffset = -140;
            const y = sectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        document.body.style.overflow = ismenulist ? "hidden" : "auto";
    }, [ismenulist]);

    const handleVegToggle = (istoggole) => {
        setVegToggle(istoggole);
        if (istoggole) {
            handleFetchDetails(coords.lat, coords.long, "1");
        } else {
            handleFetchDetails(coords.lat, coords.long, "0");
        }
    }

    return (
        <div className="pb-[50px]">
            {loading
                ? <div className="w-full h-[calc(100vh-90px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                : restuarantdata ?
                    <div className="restaurant_page">
                        <div className="mt-[20px]">

                            <div className="flex items-center gap-[10px]">
                                <button onClick={() => navigate(-1)}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.7501 12C20.7501 12.414 20.4141 12.75 20.0001 12.75H5.81115L8.53112 15.47C8.82412 15.763 8.82412 16.238 8.53112 16.531C8.38512 16.677 8.19309 16.751 8.00109 16.751C7.80909 16.751 7.61706 16.678 7.47106 16.531L3.47106 12.531C3.40206 12.462 3.3472 12.3791 3.3092 12.2871C3.2332 12.1041 3.2332 11.8971 3.3092 11.7141C3.3472 11.6221 3.40206 11.539 3.47106 11.47L7.47106 7.46999C7.76406 7.17699 8.2391 7.17699 8.5321 7.46999C8.8251 7.76299 8.8251 8.23803 8.5321 8.53103L5.81213 11.251H20.0001C20.4141 11.25 20.7501 11.586 20.7501 12Z" fill="black" />
                                    </svg>
                                </button>
                                <h1 className="main_title">{restuarantdata?.rest_title}</h1>
                            </div>

                            <div style={{ backgroundImage: `url(${BaseUrl}/${restuarantdata?.rest_img})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} className="section_1">
                                <div className="w-[400px] max-_580_:w-full bg-white rounded-[20px] p-[20px] relative">

                                    {restuarantdata.rest_is_open !== "1" && <h1 className='font-bold text-[15px] text-white bg-[--bgcolor] inline-block pt-[2px] pb-[5px] px-[10px] rounded-b-[5px] absolute top-0 left-[65%]'>Closed</h1>}

                                    <div className={` flex items-center gap-[5px] justify-between`}>
                                        <div className="flex items-center gap-[5px]">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                                <circle cx="10" cy="10" r="9" fill="url(#StoreRating20_svg__paint0_linear_32982_71567)"></circle>
                                                <path d="M10.0816 12.865C10.0312 12.8353 9.96876 12.8353 9.91839 12.865L7.31647 14.3968C6.93482 14.6214 6.47106 14.2757 6.57745 13.8458L7.27568 11.0245C7.29055 10.9644 7.26965 10.9012 7.22195 10.8618L4.95521 8.99028C4.60833 8.70388 4.78653 8.14085 5.23502 8.10619L8.23448 7.87442C8.29403 7.86982 8.34612 7.83261 8.36979 7.77777L9.54092 5.06385C9.71462 4.66132 10.2854 4.66132 10.4591 5.06385L11.6302 7.77777C11.6539 7.83261 11.706 7.86982 11.7655 7.87442L14.765 8.10619C15.2135 8.14085 15.3917 8.70388 15.0448 8.99028L12.7781 10.8618C12.7303 10.9012 12.7095 10.9644 12.7243 11.0245L13.4225 13.8458C13.5289 14.2757 13.0652 14.6214 12.6835 14.3968L10.0816 12.865Z" fill="white"></path>
                                                <defs>
                                                    <linearGradient id="StoreRating20_svg__paint0_linear_32982_71567" x1="10" y1="1" x2="10" y2="19" gradientUnits="userSpaceOnUse">
                                                        <stop stopColor="#21973B"></stop>
                                                        <stop offset="1" stopColor="#128540"></stop>
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                            <p className="font-bold text-[17px]">{restuarantdata?.rest_rating} <span className='text-[15px]'>({ratonglength} ratings)</span></p>
                                            <span className="mx-[5px] text-gray-500">•</span>
                                            <p className="font-bold text-[17px]">{currency + restuarantdata?.rest_costfortwo} for two</p>
                                        </div>

                                        {Userid && <button onClick={() => handleAddToFavorite(restuarantdata.rest_id)} className="">
                                            {isfav === 0
                                                ? <svg width="22" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.99997 18.75C9.89397 18.75 9.78793 18.728 9.68893 18.683C9.36193 18.534 1.66598 14.965 0.431976 8.609C-0.0450242 6.15 0.433982 3.75098 1.71298 2.19298C2.74798 0.930984 4.23594 0.259967 6.01694 0.250967C6.02594 0.250967 6.03494 0.250967 6.04294 0.250967C8.07494 0.250967 9.31399 1.408 9.99899 2.393C10.687 1.404 11.9359 0.241967 13.9809 0.250967C15.7629 0.259967 17.2519 0.930984 18.2879 2.19298C19.5649 3.74998 20.0429 6.14898 19.5649 8.60998C18.3329 14.966 10.6359 18.536 10.3089 18.684C10.2119 18.728 10.106 18.75 9.99997 18.75ZM6.04196 1.74999C6.03596 1.74999 6.03099 1.74999 6.02499 1.74999C4.68699 1.75599 3.62702 2.22497 2.87302 3.14397C1.87402 4.36097 1.513 6.29699 1.905 8.32299C2.86 13.247 8.59297 16.447 9.99997 17.165C11.407 16.447 17.14 13.247 18.094 8.32299C18.488 6.29599 18.127 4.35997 17.13 3.14397C16.376 2.22597 15.3159 1.75797 13.9749 1.75097C13.9689 1.75097 13.963 1.75097 13.958 1.75097C11.586 1.75097 10.745 4.12799 10.711 4.22899C10.607 4.53199 10.3209 4.73797 10.0009 4.73797C9.99895 4.73797 9.99792 4.73797 9.99692 4.73797C9.67592 4.73697 9.38993 4.53198 9.28793 4.22698C9.25493 4.12698 8.41296 1.74999 6.04196 1.74999Z" fill="black" />
                                                </svg>

                                                : <svg width="20" height="19" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.8299 7.46502C16.6569 13.515 8.99998 17 8.99998 17C8.99998 17 1.34292 13.515 0.168923 7.46502C-0.551077 3.75302 1.02197 0.018995 5.02097 -5.02745e-06C7.99997 -0.014005 8.99998 2.98797 8.99998 2.98797C8.99998 2.98797 10 -0.015005 12.978 -5.02745e-06C16.986 0.018995 18.5499 3.75402 17.8299 7.46502Z" fill="red" />
                                                </svg>
                                            }
                                        </button>}

                                    </div>

                                    <p className='text-[--bgcolor] font-bold text-[14px] underline whitespace-nowrap overflow-hidden overflow-ellipsis'>{restuarantdata?.rest_sdesc}</p>

                                    <div className="flex items-center gap-[10px] ms-[7px]">
                                        <div className="flex flex-col items-center">
                                            <div className="w-[7px] h-[7px] bg-gray-400 rounded-full"></div>
                                            <div className="w-[1px] h-[23px] bg-gray-400 rounded-full"></div>
                                            <div className="w-[7px] h-[7px] bg-gray-400 rounded-full"></div>
                                        </div>
                                        <div className="flex flex-col gap-[8px]">
                                            <div className="flex items-center gap-[15px]">
                                                <h2 className="font-bold text-[15px]">Outlet</h2>
                                                <h1 className="font-[500] text-[15px] text-gray-600">{restuarantdata?.rest_landmark}</h1>
                                            </div>
                                            <span className="font-bold text-[15px]">{restuarantdata.rest_deliverytime}-{Number(restuarantdata.rest_deliverytime) + 5} mins</span>
                                        </div>
                                    </div>

                                    <div className="mt-[8px] mb-[10px] flex items-center gap-[5px]">
                                        <svg width="20" height="22" viewBox="0 0 24 24" className="text-[--bgcolor]" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 2.5C7.313 2.5 3.5 6.313 3.5 11C3.5 15.983 8.129 19.041 11.192 21.064L11.722 21.416C11.806 21.472 11.903 21.5 11.999 21.5C12.095 21.5 12.192 21.472 12.276 21.416L12.806 21.064C15.869 19.041 20.498 15.983 20.498 11C20.5 6.313 16.687 2.5 12 2.5ZM12 13.5C10.619 13.5 9.5 12.381 9.5 11C9.5 9.619 10.619 8.5 12 8.5C13.381 8.5 14.5 9.619 14.5 11C14.5 12.381 13.381 13.5 12 13.5Z" fill="currentColor" />
                                        </svg>
                                        <span className="font-[700] text-[15px]">{restuarantdata?.rest_distance}</span>
                                    </div>

                                    <div className="border-t-[2px] pt-[10px] flex items-center gap-[10px]">
                                        <button onClick={handleCall} className="w-full flex items-center justify-center gap-[10px] text-[--bgcolor] border-e-[2px]">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.5521 21.752C16.0931 21.752 15.6311 21.69 15.1751 21.565C9.01111 19.873 4.12909 14.995 2.43609 8.83402C2.05109 7.43302 2.26204 5.97301 3.03204 4.72501C3.80504 3.47101 5.0761 2.58701 6.5191 2.29801C7.4721 2.10701 8.4281 2.53301 8.9151 3.35501L10.4781 5.99399C11.2371 7.27599 10.86 8.92799 9.61896 9.75299L8.4881 10.505C9.5451 12.676 11.3229 14.458 13.4839 15.514L14.2462 14.377C15.0752 13.138 16.7281 12.767 18.0091 13.53L20.6522 15.106C21.4702 15.594 21.8941 16.548 21.7071 17.481C21.4191 18.924 20.5341 20.195 19.2811 20.968C18.4391 21.487 17.5021 21.752 16.5521 21.752ZM6.97809 3.75C6.92909 3.75 6.87911 3.75502 6.83111 3.76502C5.77711 3.97602 4.86512 4.611 4.31012 5.512C3.76112 6.402 3.61009 7.44101 3.88409 8.43601C5.43709 14.09 9.91608 18.566 15.5721 20.118C16.5671 20.391 17.605 20.239 18.493 19.691C19.393 19.136 20.0291 18.222 20.2361 17.186C20.2981 16.875 20.1571 16.556 19.8841 16.394L17.241 14.818C16.643 14.463 15.876 14.637 15.492 15.212L14.377 16.877C14.177 17.175 13.7911 17.289 13.4651 17.151C10.5021 15.913 8.09213 13.496 6.85113 10.522C6.71313 10.19 6.82999 9.80801 7.12799 9.60901L8.78912 8.504C9.36512 8.121 9.54007 7.35401 9.18707 6.75901L7.62408 4.12C7.48708 3.887 7.23909 3.75 6.97809 3.75ZM14.869 14.794H14.879H14.869ZM17.7501 10C17.7501 7.932 16.0671 6.25 14.0001 6.25C13.5861 6.25 13.2501 6.586 13.2501 7C13.2501 7.414 13.5861 7.75 14.0001 7.75C15.2401 7.75 16.2501 8.759 16.2501 10C16.2501 10.414 16.5861 10.75 17.0001 10.75C17.4141 10.75 17.7501 10.414 17.7501 10ZM20.7501 10C20.7501 6.278 17.7221 3.25 14.0001 3.25C13.5861 3.25 13.2501 3.586 13.2501 4C13.2501 4.414 13.5861 4.75 14.0001 4.75C16.8951 4.75 19.2501 7.105 19.2501 10C19.2501 10.414 19.5861 10.75 20.0001 10.75C20.4141 10.75 20.7501 10.414 20.7501 10Z" fill="currentColor" />
                                            </svg>
                                            {!shownumber
                                                ? <span className="font-bold text-[17px]">Call</span>
                                                : <p className='font-bold'>{restuarantdata?.rest_mobile}</p>}
                                        </button>
                                        <button onClick={handleMap} className="w-full flex items-center justify-center gap-[10px] text-[--bgcolor]">
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.469 21.75C12.419 21.75 12.368 21.7479 12.317 21.7439C11.552 21.6819 10.922 21.165 10.711 20.428L9.62098 16.6121C9.30998 15.5251 8.47599 14.6909 7.38899 14.3799L3.57301 13.2901C2.83501 13.0791 2.31903 12.4491 2.25703 11.6841C2.19503 10.9191 2.60398 10.214 3.29798 9.88699L19.148 2.42899C19.851 2.09699 20.663 2.23907 21.213 2.79007C21.764 3.34007 21.905 4.15101 21.574 4.85501L14.116 20.7051C13.809 21.3511 13.174 21.75 12.469 21.75ZM19.785 3.78494L3.93501 11.243C3.75901 11.326 3.74401 11.478 3.75001 11.562C3.75601 11.646 3.79598 11.793 3.98298 11.847L7.79902 12.937C9.38802 13.391 10.608 14.61 11.061 16.199L12.151 20.0149C12.205 20.2029 12.352 20.2421 12.436 20.2481C12.52 20.2491 12.672 20.24 12.755 20.063L20.213 4.21292C20.297 4.03392 20.209 3.90696 20.149 3.84696C20.092 3.78896 19.963 3.69994 19.785 3.78494Z" fill="currentColor" />
                                            </svg>
                                            <span className="font-bold text-[17px]">Direction</span>
                                        </button>
                                    </div>

                                </div>
                            </div>

                            {couponlist.length >= 1 && <div className="section_2">
                                <h1 className="title">Deals for you</h1>
                                <div className="mt-[10px]">
                                    <div className="slider-container">
                                        <Slider {...CouponList}>
                                            {couponlist.map((item, index) => {
                                                return <div key={index} onClick={() => setShowCouponItem(item)} className="border-[1px] border-gray-300 rounded-[16px] p-[12px] cursor-pointer">
                                                    <div className="flex items-center gap-[10px]">
                                                        <img src={`${BaseUrl}/${item.c_img}`} className="w-[50px] h-[50px] object-cover rounded-[10px]" alt="c_img" />
                                                        <div className="leading-6">
                                                            <h1 className="font-bold text-[18px]">Extra {item.coupon_title}</h1>
                                                            <p className="font-bold text-[14px] text-gray-500">USE {item.coupon_code} | ABOVE {currency + item.min_amt}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                            </div>}

                            <div className="flex flex-col-reverse md:flex-row md:items-center gap-3 md:gap-[10px] border-b border-gray-200 py-4 md:py-5">

                                <div className="flex-shrink-0">
                                    {restuarantdata?.rest_is_veg == 0 ? (
                                        <div className="swith">
                                            <div
                                                onClick={() => handleVegToggle(!vegtoggle)}
                                                className="line cursor-pointer"
                                            >
                                                <input type="checkbox" className="w-0 h-0 opacity-0" />
                                                <div className={vegtoggle ? "icon_box_open" : "icon_box"}>
                                                    <div className={vegtoggle ? "icon_open" : "icon"}>
                                                        <img src={VegIcon} alt="VegIcon" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="w-fit md:w-[110px] border px-3 py-2 rounded-xl flex items-center gap-2">
                                            <img src={PureVegIcon} className="w-5" alt="Pure Veg" />
                                            <h1 className="whitespace-nowrap font-medium text-green-600 text-sm md:text-base">
                                                Pure Veg
                                            </h1>
                                        </div>
                                    )}
                                </div>
                                <div onClick={handleSearch} className="w-full flex items-center justify-between gap-3 bg-[#e9eceeb6] p-3 md:p-[10px] md:px-[15px] rounded-xl relative cursor-pointer">
                                    <p className="font-medium text-gray-400 text-sm md:text-base w-full truncate text-center md:text-left">
                                        Search in restaurant {restuarantdata?.rest_title}
                                    </p>
                                    <svg width="20" height="20" className='' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="#25314C" /> </svg>
                                </div>
                            </div>


                            <div className="section_3">
                                {itemlist.map((item, index) => {
                                    return <ProductData key={item.id} sectionRefs={sectionRefs} index={index} item={item} itemlist={itemlist} currency={currency} setSelectItem={setSelectItem} handleAllFuction={handleAllFuction} status={restuarantdata} />
                                })}
                            </div>

                            {restuarantdata?.rest_licence && <div className="flex items-center gap-[15px]">
                                <img src={FssaiLogo} className='w-[70px]' alt="FssaiLogo" />
                                <h1 className='font-medium text-gray-500'>Licenes No. {restuarantdata?.rest_licence}</h1>
                            </div>}

                        </div>

                        <div className="bottome_box">
                            <div className="relative">
                                <div className="absolute -top-[85px] left-[68%] z-[222]">
                                    <button onClick={() => handleMenuOpenClose(1)} className="menu_text">
                                        <h1>MENU</h1>
                                    </button>
                                </div>
                                {totalcart >= 1 && <Link to="/checkout" className="cart_box">
                                    <h1 className="font-bold text-[16px]">{totalcart} item added</h1>
                                    <div className="flex items-center gap-[5px]">
                                        <h1 className="font-bold text-[16px]">VIEW CART</h1>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.27 21C10.27 21.69 9.71002 22.25 9.02002 22.25C8.33102 22.25 7.76501 21.69 7.76501 21C7.76501 20.31 8.32001 19.75 9.01001 19.75H9.02002C9.71002 19.75 10.27 20.31 10.27 21ZM17.02 19.75H17.01C16.32 19.75 15.765 20.31 15.765 21C15.765 21.69 16.33 22.25 17.02 22.25C17.71 22.25 18.27 21.69 18.27 21C18.27 20.31 17.71 19.75 17.02 19.75ZM21.705 8.492L20.691 14.658C20.428 16.104 19.774 17.75 17 17.75H8.73401C7.37501 17.75 6.20396 16.735 6.01196 15.389L4.50195 4.82401C4.41395 4.21201 3.88301 3.75101 3.26501 3.75101H3C2.586 3.75101 2.25 3.41501 2.25 3.00101C2.25 2.58701 2.586 2.25101 3 2.25101H3.26599C4.62499 2.25101 5.79604 3.266 5.98804 4.612L6.07996 5.25101H19C19.818 5.25101 20.5881 5.611 21.1121 6.239C21.6351 6.866 21.852 7.688 21.705 8.492ZM19.213 14.403L19.3199 13.75H13C12.586 13.75 12.25 13.414 12.25 13C12.25 12.586 12.586 12.25 13 12.25H19.567L20.2271 8.23599C20.2961 7.85799 20.198 7.484 19.959 7.19901C19.72 6.91401 19.371 6.75 18.999 6.75H6.29297L7.49695 15.177C7.58495 15.789 8.11601 16.25 8.73401 16.25H17C18.597 16.25 18.986 15.654 19.213 14.403Z" fill="white" />
                                        </svg>
                                    </div>
                                </Link>}
                            </div>
                        </div>


                    </div>
                    : <NotFound />}

            {iscustomisable && <div onClick={() => handleCloseModel(1)} className="model items-center max-_430_:items-end">
                <div onClick={(e) => e.stopPropagation()} className="customisable_box">

                    <div className="py-[20px] px-[15px]">
                        <div className="flex items-center justify-between">
                            <h1 className="text-[15px] text-gray-600">{selectitem?.title} • {currency + selectitem?.price}</h1>
                            <button onClick={() => handleCloseModel(1)} className="bg-white rounded-full p-[4px] box_shadow" >
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                </svg>
                            </button>
                        </div>
                        <p className="text-[20px] font-bold text-gray-800 border-b-[1px] pb-[10px] border-gray-300">Customise as per your taste</p>
                    </div>

                    {!subaddonshow && <div className="h-[100%] pb-[20px] px-[15px] scroll_container">
                        {customisableitem.addondata.map((addon, index) => {
                            const Required = addon.addon_limit;
                            return <div key={index} className="addondata_box" >
                                <div className="flex items-center gap-[10px]">
                                    <h1 className="title">{addon.title}</h1>
                                    {addon.addon_is_radio === "1"
                                        ? <span className="font-bold text-[16px] text-gray-500">
                                            ({addon.additem || "0"}/{"1"})
                                        </span>
                                        : (Required !== "0" && <span className="font-bold text-[16px] text-gray-500">
                                            ({addon.additem || "0"}/{Required})
                                        </span>)}
                                </div>

                                <div className="bg-white pt-[10px] px-[15px] rounded-[10px] my-[10px]">
                                    {addon.addon_item_data.map((dataItem, index) => {
                                        const hasSubAddon = dataItem.subaddondata?.length >= 1;
                                        return (
                                            <AddonItemData
                                                index={index}
                                                Required={Required}
                                                key={dataItem.id}
                                                addondata={addon}
                                                data={dataItem}
                                                currency={currency}
                                                setSelectAddonItem={setSelectAddonItem}
                                                selectaddonitem={selectaddonitem}
                                                hasSubAddon={hasSubAddon}
                                                setSubAddonData={setSubAddonData}
                                                setItemState={setItemState}
                                                itemstate={itemstate}
                                                isedit={0}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        })}
                    </div>}

                    {subaddonshow && <div className="h-[100%] pb-[20px] px-[15px] scroll_container">

                        <div className="bg-white px-[15px] py-[20px] rounded-[10px] mb-[10px]">
                            <div className="flex items-center gap-[10] justify-between">
                                <h1 className="font-[500] text-[16px]">• {subAddonData?.title}</h1>
                                <button onClick={() => handleCloseModel(2)} className="font-bold text-[16px] text-[--bgcolor]">Change</button>
                            </div>
                        </div>

                        {subAddonData.subaddondata.map((addon, index) => {
                            const Required = addon.addon_limit;
                            return <div key={index} className="addondata_box">
                                <div className="flex items-center gap-[10px]">
                                    <h1 className="title">{addon.title}</h1>
                                    {addon.addon_is_radio === "1"
                                        ? <span className="font-bold text-[16px] text-gray-500">
                                            ({addon.additem || "0"}/{addon.addon_is_required})
                                        </span>
                                        : (Required !== "0" && <span className="font-bold text-[16px] text-gray-500">
                                            ({addon.additem || "0"}/{Required})
                                        </span>)}
                                </div>

                                <div className="bg-white pt-[10px] px-[15px] rounded-[10px] my-[10px]">
                                    {addon.subon_item_data.map((dataItem, index) => {
                                        return (
                                            <SubAddonItemData
                                                index={index}
                                                Required={Required}
                                                key={dataItem.id}
                                                addondata={addon}
                                                data={dataItem}
                                                currency={currency}
                                                hasSubAddon={true}
                                                setSubAddonData={setSubAddonData}
                                                subAddonData={subAddonData}
                                                setItemState={setItemState}
                                                itemstate={itemstate}
                                                selectaddonitem={selectaddonitem}
                                                isedit={0}
                                            />
                                        );
                                    })}
                                </div>

                            </div>
                        })}
                    </div>}

                    <div className="bg-white p-[16px] flex items-center justify-between gap-[20px]">
                        <div className="font-bold text-[18px]">
                            {addonlimit !== 0 ? ((!subaddonshow)
                                ? <h1>Step ({isstep}/{addonlimit})</h1>
                                : <h1>{currency}{Number(selectitemprice) + Number(selectitem?.price)} </h1>)
                                : <h1>{currency}{Number(selectitemprice) + Number(selectitem?.price)} </h1>}
                        </div>
                        <button onClick={() => (addonlimit !== 0 && !subaddonshow) ? handleContinue() : handleAddToCart(customisableitem)} className="w-[300px] bg-[rgb(27,166,114)] text-white font-bold text-[18px] py-[8px] rounded-[12px]">
                            {(addonlimit !== 0 && !subaddonshow)
                                ? <span>Continue</span>
                                : <span>Add Item to cart</span>}
                        </button>
                    </div>

                </div>

            </div>}

            {showcouponitem && <div onClick={() => setShowCouponItem("")} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="coupon_box">
                    <div className="border-b-[1px] pb-[15px] border-gray-300">
                        <div className="flex items-center justify-between">
                            <h1 className="title">Additional {currency + showcouponitem?.c_value} off on this order</h1>
                            <button onClick={() => setShowCouponItem("")} className="bg-white rounded-full p-[4px] box_shadow" >
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                </svg>
                            </button>
                        </div>
                        <p className="text-[17px] text-gray-800">Use code {showcouponitem?.coupon_code} & get {showcouponitem?.coupon_title} on orders above {currency + showcouponitem?.min_amt}</p>
                    </div>

                    <div className="pt-[10px] text-[rgba(2,6,12,0.75)]">
                        <h1 className="font-[700] text-[15px]">Terms and Conditions</h1>
                        <p className="c_desc flex items-center m-0 gap-[7px] mt-[5px]" dangerouslySetInnerHTML={{ __html: "•" + showcouponitem?.c_desc }} />
                        <p className=" text-[16px] font-[600] mt-[5px]">• Offer valid till {formatCustomDate(showcouponitem?.cdate)}</p>
                    </div>
                </div>
            </div>}

            {isrepeat && <div onClick={() => handleCloseModel(3)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="bg-[#f1f2f4] w-[500px] flex flex-col max-h-[80vh] rounded-[15px] overflow-hidden">

                    <div className="py-[20px] px-[15px]">
                        <div className="flex items-center justify-between">
                            <h1 className="text-[16px] text-gray-600">{selectitem?.title}</h1>
                            <button onClick={() => handleCloseModel(3)} className="bg-white rounded-full p-[4px] box_shadow" >
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                </svg>
                            </button>
                        </div>
                        <p className="text-[22px] font-bold text-[rgba(2,6,12,0.75)] border-gray-300 -mt-[10px]">Repeat previous customisation?</p>
                    </div>

                    <div className="h-[100%] mx-[15px] scroll_container">
                        {repeatorderlist.map((order, orderindex) => {
                            const isSelect = orderindex === (selectrepeatorder - 1);
                            return order.addon.map((addon, addonindex) => {
                                return <div key={addonindex} onClick={() => setSelectRepeatOrder(orderindex + 1)} className={` ${repeatradiobtn ? "cursor-pointer" : "cursor-auto"} my-[8px] bg-white px-[15px] py-[10px] rounded-[10px]`}>
                                    <div className="flex items-center justify-between gap-[20px]">
                                        <h1 className="font-[600] text-gray-800">{addon.title} {addon.title === "Order" && orderindex + 1}</h1>
                                        {repeatradiobtn && <div className={`${isSelect ? "border-[#ff5200]" : "border-gray-500"} border-[2px] rounded-full p-[3px]`}>
                                            <div className={`w-[8px] h-[8px] ${isSelect ? "bg-[#ff5200]" : "bg-transparent"} rounded-full`}></div>
                                        </div>}
                                    </div>
                                    {addon.data.length >= 1
                                        ? addon.data?.map((item, itemIndex) => (
                                            <h1 key={itemIndex} className="text-[rgba(2,6,12,0.75)]">• {item.title}</h1>
                                        ))
                                        : <h1 className="text-[rgba(2,6,12,0.75)]">• {order.title}</h1>}
                                </div>
                            })
                        })}
                    </div>

                    <div className="bg-white p-[16px] flex items-center justify-between gap-[20px] mt-[20px]">
                        <button onClick={handleUserChoose} className="w-full border-[1px] border-[rgb(27,166,114)] text-[rgb(27,166,114)] font-bold text-[16px] py-[8px] rounded-[12px]">I’ll choose</button>
                        <button onClick={handleRepeatOrder} className="w-full bg-[rgb(27,166,114)] text-white font-bold text-[16px] py-[8px] rounded-[12px]">Repeat</button>
                    </div>
                </div>
            </div>}

            {ismenulist && <div onClick={() => handleMenuOpenClose(2)} className="model items-end pb-[10px]">
                <div ref={MenuListRef} onClick={(e) => e.stopPropagation()} style={{ width: "450px", transform: "translateY(290px) scale(0)" }} className="max-h-[400px] scroll_container menu_list">
                    {itemlist.map((item, index) => {
                        return <div key={index} onClick={() => handleScrollToSection(item.id)} className="py-[10px] cursor-pointer flex items-center justify-between gap-[10px] overflow-hidden">
                            <h1 className="text-white font-bold text-[16px] whitespace-nowrap overflow-hidden overflow-ellipsis">{item.title}</h1>
                            <span className="text-white font-bold text-[16px]">{item.Menuitem_Data.length}</span>
                        </div>
                    })}
                </div>
            </div>}

            {isshow && <div onClick={handleShowModel} className="w-full h-[100vh] fixed left-0 right-0 bottom-0 flex items-end justify-center z-[888]">
                <div ref={StyleRef} onClick={(e) => e.stopPropagation()} className="item_added">
                    <h1>Items already in cart</h1>
                    <p className="text-[15px] leading-5 text-[rgba(2,6,12,.8)] font-[500]">Your cart contains items from other restaurant. Would you like to reset your cart for adding items from this restaurant?</p>
                    <div className="flex items-center gap-[20px] mt-[20px]">
                        <button onClick={handleShowModel} className="w-full border-[2px] border-[#1ba672] text-[#1ba672] font-bold text-[15px] py-[10px] hover:shadow-lg rounded-[10px]">NO</button>
                        <button onClick={() => handleShowModel(1)} className="w-full border-[2px] border-[#1ba672] bg-[#1ba672] text-white font-bold text-[15px] py-[10px] hover:shadow-lg rounded-[10px]">YES, START AFRESH</button>
                    </div>
                </div>
            </div>}

        </div >
    )
}
export default RestaurantsDetails;
